import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PayslipList = ({ payslips, onGeneratePDF, loading }) => {
  const statusColors = {
    draft: 'bg-muted text-muted-foreground',
    generated: 'bg-success/10 text-success',
    sent: 'bg-primary/10 text-primary',
    failed: 'bg-error/10 text-error'
  };

  const statusIcons = {
    draft: 'FileText',
    generated: 'CheckCircle',
    sent: 'Send',
    failed: 'AlertTriangle'
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Icon name="Loader2" className="animate-spin h-8 w-8 text-primary" />
      </div>
    );
  }

  if (!payslips || payslips?.length === 0) {
    return (
      <div className="text-center py-12">
        <Icon name="FileText" size={48} className="mx-auto mb-4 text-muted-foreground" />
        <p className="text-muted-foreground">No payslips generated yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {payslips?.map((payslip) => (
        <div key={payslip?.id} className="bg-card border border-border rounded-lg p-4">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <h4 className="font-semibold text-foreground">
                  {payslip?.employee?.firstName} {payslip?.employee?.lastName}
                </h4>
                <span className={`px-2 py-1 rounded text-xs font-medium ${statusColors?.[payslip?.payslipStatus]}`}>
                  <Icon name={statusIcons?.[payslip?.payslipStatus]} size={12} className="inline mr-1" />
                  {payslip?.payslipStatus?.toUpperCase()}
                </span>
              </div>
              <div className="flex items-center gap-4 text-sm text-muted-foreground">
                <span>
                  <Icon name="Hash" size={14} className="inline mr-1" />
                  {payslip?.payslipNumber}
                </span>
                <span>
                  <Icon name="Building" size={14} className="inline mr-1" />
                  {payslip?.employee?.department}
                </span>
                <span>
                  <Icon name="Calendar" size={14} className="inline mr-1" />
                  {new Date(payslip?.paymentDate)?.toLocaleDateString()}
                </span>
              </div>
              {payslip?.errorMessage && (
                <p className="text-xs text-error mt-2">
                  <Icon name="AlertTriangle" size={12} className="inline mr-1" />
                  {payslip?.errorMessage}
                </p>
              )}
            </div>
            <div className="flex items-center gap-2">
              {payslip?.payslipStatus === 'generated' && (
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Download"
                  onClick={() => onGeneratePDF(payslip)}
                >
                  Download PDF
                </Button>
              )}
              {payslip?.payslipStatus === 'sent' && (
                <Button variant="outline" size="sm" iconName="Eye">
                  View
                </Button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PayslipList;